import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/delete_carrier_account_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .confirm_delete': 'deleteCarrierAccount',
  },

  context() {
    return {
      id: this.model.id,
      readable: this.model.get('readable'),
    };
  },

  deleteCarrierAccount(event) {
    event.preventDefault();

    this.model.destroy({
      wait: true
    });

    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/delete_carrier_account_modal.js